import { useEffect } from 'react';
import { useStore } from './store';
import { api, configureApi } from './lib/api';
import { gateway } from './lib/gateway';
import { clearCredentials, getCredentials } from './lib/platform';
import { Onboarding } from './components/Onboarding';
import { Workspace } from './components/Workspace';
import { Toasts } from './components/Toasts';
import { ErrorBoundary } from './components/ErrorBoundary';

function AppBar() {
  const serverUrl = useStore((s) => s.serverUrl);
  const phase = useStore((s) => s.phase);

  return (
    <div className="appbar">
      <img src="/logo.png" alt="" className="appbar-logo" />
      <span className="appbar-name">CallZone</span>
      {phase === 'ready' && serverUrl && <span className="appbar-server">{serverUrl}</span>}
    </div>
  );
}

export default function App() {
  const phase = useStore((s) => s.phase);
  const connectionError = useStore((s) => s.connectionError);

  /** Ao abrir, tenta reusar o token guardado neste navegador. */
  useEffect(() => {
    let cancelled = false;

    async function boot() {
      const store = useStore.getState();
      const saved = getCredentials();

      if (!saved) {
        if (!cancelled) store.setPhase('onboarding');
        return;
      }

      configureApi(saved.serverUrl, saved.token);
      store.setConnection(saved.serverUrl, saved.token);

      try {
        const { user } = await api.me();
        if (cancelled) return;
        store.setMe(user);
        store.setPhase('connecting');
        gateway.connect(saved.token);
      } catch {
        if (cancelled) return;
        // Token revogado ou servidor fora do ar: volta para a tela de acesso.
        clearCredentials();
        store.setPhase('onboarding');
      }
    }

    void boot();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="app">
      <AppBar />
      {connectionError && phase === 'ready' && <div className="banner">{connectionError}</div>}
      {phase === 'boot' && <div className="empty-state">Abrindo o CallZone...</div>}
      {phase === 'onboarding' && <Onboarding />}
      {phase === 'connecting' && <div className="empty-state">Conectando ao servidor...</div>}
      <ErrorBoundary>
        {phase === 'ready' && <Workspace />}
      </ErrorBoundary>
      <Toasts />
    </div>
  );
}
